module.exports = __webpack_public_path__ + "static/media/29ADMSPC5.98e9b1b5.jpg";